import React, { useRef } from 'react';
import { InView } from 'react-intersection-observer';

import useEventTracking from '@hooks/useEventTracking';
import { ImpressionElement, impression } from '@tracking';

import type { AnalyticsWrapperProps } from './interfaces';
import useAnalyticsWrapper from './useAnalyticsWrapper';

const AnalyticsWrapper = ({
  children,
  shouldTrackClick,
  shouldTrackImpression,
  trackingLocation,
}: AnalyticsWrapperProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { Track, trackEvent } = useEventTracking({
    ...(trackingLocation ? { location: trackingLocation } : {}),
  });
  useAnalyticsWrapper({ shouldTrackClick, trackEvent, containerRef });

  const Children = () => <Track>{children}</Track>;

  const ContentWithPossibleImpression = () =>
    shouldTrackImpression ? (
      <InView
        triggerOnce={true}
        onChange={(inView) => {
          inView && trackEvent(impression({ impressionElement: ImpressionElement.PageTemplates }));
        }}
      >
        <Children />
      </InView>
    ) : (
      <Children />
    );

  return !shouldTrackClick ? (
    <ContentWithPossibleImpression />
  ) : (
    <div ref={containerRef}>{<ContentWithPossibleImpression />}</div>
  );
};

export default AnalyticsWrapper;
